import Vue from 'vue'
import Router from 'vue-router'
// 整体 entirty
import EntiretyHome from '@/pages/entirety/EntiretyHome'
import EntiretyDetail from '@/pages/entirety/EntiretyDetail'
import EntiretyProduct from '@/pages/entirety/EntiretyProduct'
// 运营operate
import Operate from '@/pages/operate/Operate'
import OperateDetail from '@/pages/operate/OperateDetail'
// 登录
import Login from '@/pages/login'
// 首页
import Index from '@/pages/index'
Vue.use(Router)

export default new Router({
  routes: [
    // 登录
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (to.meta.title) {
          document.title = to.meta.title
        }
        next()
      },
      meta: {
        title: '业绩看板'
      }
    },
    // 首页
    {
      path: '/',
      name: 'index',
      component: Index,
      beforeEnter: (to, from, next) => {
        if (to.meta.title) {
          document.title = to.meta.title
        }
        next()
      },
      meta: {
        title: '业绩看板'
      }
    },
    {
      path: '/entirety',
      name: 'EntiretyHome',
      component: EntiretyHome,
      beforeEnter: (to, from, next) => {
        if (to.meta.title) {
          document.title = to.meta.title
        }
        next()
      },
      meta: {
        title: '整体'
      }
    },
    {
      path: '/entiretyDetail',
      name: 'EntiretyDetail',
      component: EntiretyDetail,
      beforeEnter: (to, from, next) => {
        // document.title = ' '
        next()
      }
    },
    {
      path: '/entiretyProduct',
      name: 'EntiretyProduct',
      component: EntiretyProduct,
      beforeEnter: (to, from, next) => {
        // document.title = localStorage.getItem('analyseName')
        next()
      }
    },
    //  运营
    {
      path: '/operate',
      name: 'Operate',
      component: Operate,
      beforeEnter: (to, from, next) => {
        if (to.meta.title) {
          document.title = to.meta.title
        }
        next()
      },
      meta: {
        title: '运营'
      }
    },
    {
      path: '/operateDetail',
      name: 'OperateDetail',
      component: OperateDetail,
      beforeEnter: (to, from, next) => {
        // document.title = ' '
        next()
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js